import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../../views/component-base';
import { OnDestroy } from '@angular/core';
import { NgwWowService } from 'ngx-wow';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-certificate-of-employment-edit-view',
  templateUrl: './certificate-of-employment-edit.component.html',
  styleUrls: ['./certificate-of-employment-edit.component.scss'],
  host: {
    class: 'w-100'
  }
})
export class CertificateOfEmploymentEditComponent extends ComponentBase implements OnInit, OnDestroy {

  constructor(public store: Store<AppState>,
    private wowService: NgwWowService,
    private router: Router
  ) {
    super();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      this.wowService.init();
    });

  }

  ngOnInit() {
    super.ngOnInitBase();
    this.screenWidthChange(this.store, (width: number) => {
    });
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

}
